import { defineComponent as _defineComponent } from 'vue'
import { Badge, getBadgeKeys } from './badge';
import { convertToHtmlHelper as convertToHtml } from '@/heplers';
import type { ChildParams } from '@/templates/References';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApiRequestReturnParams',
  props: {
    parameters: null
  },
  setup(__props: any) {



return { __sfc: true,Badge, getBadgeKeys, convertToHtml }
}

})